import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Permissions } from './models/permissions';
import { ApiRoutes } from './services/apiroutes';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {
  base_url = ApiRoutes.Core;

  constructor(private router: Router, private http: HttpClient) { }

  getPagePermissions(key): Observable<Permissions> {
    if (key != null) {
      let url = `${this.base_url}page_permissions/${key}/`;
      return this.http.get<Permissions>(url);
    }
  }
}
